var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconCriticalPath(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11837_115260)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.2936 0H1.31631V1.05H10.789L12.6065 3.32109L11.3394 5.49818H2.3683L0 8.87409L2.3683 12.25H9.43505C9.63774 13.2485 10.5205 14 11.5788 14C12.7869 14 13.7663 13.0206 13.7663 11.8125C13.7663 10.6044 12.7869 9.625 11.5788 9.625C10.5833 9.625 9.7431 10.29 9.4782 11.2H2.91431L1.28261 8.87409L2.91431 6.54818H11.9432L13.8761 3.22709L11.2936 0ZM12.7163 11.8125C12.7163 12.4407 12.207 12.95 11.5788 12.95C10.9506 12.95 10.4413 12.4407 10.4413 11.8125C10.4413 11.1843 10.9506 10.675 11.5788 10.675C12.207 10.675 12.7163 11.1843 12.7163 11.8125Z",
    fill: "#000000"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11837_115260"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCriticalPath);
export default __webpack_public_path__ + "static/media/icon--critical-path.c43b4c690b289143132f88e04e8d4e68.svg";
export { ForwardRef as ReactComponent };